<template>
  <div class="container">
    <confirm-dialog
      v-model="deleteDialog"
      :selected="selectedProject"
      @confirmed="deleteProject"
    ></confirm-dialog>

    <page-header
      :has-create="hasCreate"
      @click:create="openCreateProjectPopup()"
    >
      <template v-slot:right>
        <div
          v-for="item in customButtons"
          class="level-item"
          :key="item.buttonID"
        >
          <a class="button" :href="item.titleLink" target="_blank">
            <span>{{ item.title }}</span>
          </a>
        </div>
      </template>
    </page-header>

    <app-modal
      v-model="createProjectDialog"
      :title="createPopupTitle"
      no-margin
    >
      <project-form-tabs
        v-model="selectedProject"
        @create="createProject"
        @update="updateProject"
      ></project-form-tabs>
    </app-modal>

    <div class="columns">
      <div class="column is-12 is-project-view">
        <app-data-view-header
          :has-create="false"
          :view-by.sync="viewBy"
          :search.sync="search"
          :headers="headers"
          :sort="sortSettings"
          :order-by.sync="orderBy"
          is-small
        >
        </app-data-view-header>

        <app-data-viewer
          :has-duplicate="hasPermission([30001, 30002])"
          :grid-has-edit="hasPermission([30001, 30002])"
          :grid-has-delete="hasPermission([30002])"
          :loading="loadingList"
          :order-by.sync="orderBy"
          :items="filteredItems"
          :view-by="viewBy"
          :headers="headers"
          @click:duplicate="duplicateProject($event)"
          @click:grid-item="
            $router.push({
              name: 'projects.details',
              params: { projectID: $event.projectID }
            })
          "
          @click:grid-edit="openEditProjectPopup($event)"
          @click:grid-delete="
            deleteDialog = true;
            selectedProject = $event;
          "
          @click:list-row="
            $router.push({
              name: 'projects.details',
              params: { projectID: $event.projectID }
            })
          "
        >
          <template v-slot:grid.team="{ item }">
            <div
              class="background"
              :class="['is-gradient-' + item.coverHtmlColor1]"
              :style="styleBackground(item.coverImageContentUrl)"
            ></div>
          </template>
          <template v-slot:grid.subtitle="{ item }">
            <div class="title">{{ item.name }}</div>
            <div class="subtitle">
              {{ $store.getters['groups/byId'](item.groupID) | get('name') }}
            </div>
          </template>
          <template v-slot:list.item.actions="{ item }">
            <button
              class="button is-text is-icon"
              @click.stop="duplicateProject(item)"
            >
              <span class="icon icon-duplicate"></span>
            </button>
            <button
              class="button is-text is-icon"
              @click.stop="
                $router.push({
                  name: 'projects.details',
                  params: { projectID: item.projectID }
                })
              "
            >
              <span class="icon icon-edit"></span>
            </button>
            <button
              class="button is-text is-icon"
              @click.stop="
                deleteDialog = true;
                selectedProject = item;
              "
            >
              <span class="icon icon-delete"></span>
            </button>
          </template>

          <template v-slot:list.item.date="{ item }">
            {{ item.createdOnUTC | toDateStr }}
          </template>
          <template v-slot:list.item.group="{ item }">
            {{ $store.getters['groups/byId'](item.groupID) | get('name') }}
          </template>
        </app-data-viewer>

        <!-- <app-table
          :items="filteredItems"
          :headers="headers"
          :click-row-access="hasPermission(40000)"
          @click:row="
            $router.push({
              name: 'projects.view',
              params: { id: $event.projectID }
            })
          "
        >
          
         
        </app-table> -->
      </div>
      <!-- DONT ERASE -->
      <!--div class="column is-3">
        <app-feed></app-feed>
      </div-->
    </div>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable.vue';
import Search from '@/components/Search.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import TableTitle from '@/components/TableTitle.vue';
import AppFeed from '@/components/feed/AppFeed';
import moment from 'moment';
import _ from 'lodash';
import AppDataViewHeader from '@/components/AppDataViewHeader.vue';
import AppDataViewer from '@/components/AppDataViewer.vue';
import PageHeader from '@/components/PageHeader.vue';
import AppModal from '@/components/AppModal';
import ProjectFormTabs from '@/components/forms/ProjectFormTab.vue';
import FilesHelper from '@/mixins/Files.js';

export default {
  name: 'ProjectsLists',
  components: {
    ProjectFormTabs,
    AppTable,
    Search,
    ConfirmDialog,
    TableTitle,
    AppFeed,
    AppDataViewHeader,
    AppDataViewer,
    PageHeader,
    AppModal
  },
  props: ['organizationID'],
  mixins: [FilesHelper],
  data() {
    return {
      create: false,
      headers: [
        {
          text: 'Project name',
          value: 'name',
          sortable: true,
          sortDirection: 1,
          customSort: (a, b) => {
            if (a.__name < b.__name) {
              return -1;
            }
            if (a.__name > b.__name) {
              return 1;
            }
            return 0;
          }
        },
        {
          text: 'Date',
          value: 'date',
          width: 180,
          sortDirection: 1,
          sortable: true,
          customSort: (a, b) => {
            if (moment(a.createdOnUTC).isBefore(b.createdOnUTC)) {
              return -1;
            }
            if (moment(a.createdOnUTC).isAfter(b.createdOnUTC)) {
              return 1;
            }
            return 0;
          }
        },
        {
          text: 'Association',
          value: 'group'
        },
        {
          text: '',
          value: 'actions',
          align: 'end',
          width: 220,
          permissions: [30002, 30001]
        }
      ],
      sortSettings: [
        {
          text: 'Newest → Oldest',
          value: 'date',
          width: 180,
          sortDirection: -1,
          customSort: (a, b) => {
            if (moment(a.createdOnUTC).isBefore(b.createdOnUTC)) {
              return -1;
            }
            if (moment(a.createdOnUTC).isAfter(b.createdOnUTC)) {
              return 1;
            }
            return 0;
          }
        },
        {
          text: 'Oldest → Newest',
          value: 'date',
          width: 180,
          sortDirection: 1,
          customSort: (a, b) => {
            if (moment(a.createdOnUTC).isBefore(b.createdOnUTC)) {
              return 1;
            }
            if (moment(a.createdOnUTC).isAfter(b.createdOnUTC)) {
              return -1;
            }
            return 0;
          }
        },
        {
          text: 'A → Z',
          value: 'name',
          sortDirection: 1,
          customSort: (a, b) => {
            if (a.__name < b.__name) {
              return 1;
            }
            if (a.__name > b.__name) {
              return -1;
            }
            return 0;
          }
        },
        {
          text: 'Z → A',
          value: 'name',
          sortDirection: -1,
          customSort: (a, b) => {
            if (a.__name < b.__name) {
              return -1;
            }
            if (a.__name > b.__name) {
              return 1;
            }
            return 0;
          }
        }
      ],
      selectedProject: {},
      deleteDialog: false,
      loadingList: true,
      search: '',
      viewBy: 'grid',
      orderBy: {
        date: -1
      },
      foo: {},
      createProjectDialog: false,
      customButtons: [],
      createPopupTitle: ''
    };
  },
  computed: {
    hasCreate() {
      return this.hasPermission([30002]);
    },
    filteredItems() {
      const items = this.$store.getters['projects/search'](this.search);
      const users = this.$store.getters['users/list'];
      /*const users = _.groupBy(
        this.$store.getters['users/unwindRoles'],
        'roles.groupID'
      );*/

      items.map(project => {
        const project_users = [];
        const group = this.$store.getters['groups/byId'](project.groupID);
        let groupLevel = '';
        if (group) {
          switch (group.organizationLevel) {
            case 'Organization':
              groupLevel = 10;
              break;
            case 'Division':
              groupLevel = 20;
              break;
            case 'Workgroup':
              groupLevel = 30;
              break;
          }

          for (let i = 0; i < users.length; i++) {
            for (let j = 0; j < users[i].roles.length; j++) {
              //if you are UEG admin you have total access
              if (users[i].roles[j].roleID == 10) {
                project_users.push(users[i]);
                break;
              } else if (
                group.organizationID == users[i].roles[j].organizationID &&
                users[i].roles[j].roleID >= groupLevel
              ) {
                project_users.push(users[i]);
                break;
              }
            }
          }
        }
        project.users = project_users;
      });

      return items;
      /*
      return items.map(project => ({
        ...project,
        users: _.get(users, project.groupID, [])
      }));
      */
    }
    // ...mapGetters({ projects: 'projects/list' })
  },
  mounted() {
    this.$store.commit('projects/set', []);
    const organizationID = this.hasRole('ueg')
      ? this.organizationID || this.$store.getters.userOrganization
      : this.$store.getters.userOrganization;

    this.axiosRequest('get', 'Projects', {
      IncludeTrashed: false,
      OrganizationId: organizationID
      /*,
      GroupID: this.$store.getters.userGroup*/
    })
      .then(response => {
        this.$store.commit('projects/set', response.data);
        this.loadingList = false;
      })
      .catch(error => {
        this.showErrorMessage(error);
      });

    //load custom buttons
    const organization = this.$store.getters['organizations/byId'](
      organizationID
    );

    let buttons = [];
    for (let i = 0; i < organization.groups.length; i++) {
      for (let j = 0; j < organization.groups[i].buttons.length; j++) {
        buttons.push(organization.groups[i].buttons[j]);
      }
    }
    this.customButtons = buttons;
  },
  methods: {
    styleBackground(url) {
      if (url) {
        return 'background-image: url(' + url + ')';
      }
      return '';
    },
    duplicateProject(item) {
      console.log('duplicate ', item);

      this.createProjectDialog = true;
      this.selectedProject = Object.assign({}, item);
      delete this.selectedProject.projectID;
      for (let i = 0; i < this.selectedProject.buttons.length; i++) {
        delete this.selectedProject.buttons[i].buttonID;
      }
      this.selectedProject.name = this.selectedProject.name + ' copy';

      this.createPopupTitle = 'Create New Project';
    },
    handleButtonsManagement(buttons, data) {
      let group = this.$store.getters['groups/byId'](data.groupID);
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].organizationID = group.organizationID;
        buttons[i].projectID = data.projectID;
        if (!buttons[i].deleted) {
          this.saveButton(buttons[i]);
        } else {
          this.deleteButton(buttons[i]);
        }
      }
    },
    openCreateProjectPopup() {
      this.createProjectDialog = true;
      this.selectedProject = {};
      this.createPopupTitle = 'Create New Project';
    },
    openEditProjectPopup(item) {
      this.createProjectDialog = true;
      //this.selectedProject = item;
      this.selectedProject = {};
      this.selectedProject = this.$store.getters['projects/byId'](
        item.projectID
      );
      this.createPopupTitle = 'Edit Project';
    },
    createProject(buttons, fileBlob) {
      // console.log(this.selectedProject);

      this.axiosRequest('post', `Projects`, this.selectedProject)
        .then(response => {
          this.$store.commit('projects/add', response.data);
          //this.createProjectDialog = false;

          this.handleButtonsManagement(buttons, response.data);

          this.selectedProject = response.data;
          this.showSuccessMessage('New project created.');

          if (fileBlob) {
            this.uploadCover(fileBlob, this.selectedProject);
          }
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    updateProject(buttons) {
      this.axiosRequest(
        'PUT',
        `Projects/${this.selectedProject.projectID}`,
        this.selectedProject
      )
        .then(response => {
          this.$store.commit('projects/edit', response.data);
          this.createProjectDialog = false;
          this.selectedProject = {};
          this.showSuccessMessage('Project updated.');

          this.handleButtonsManagement(buttons, response.data);
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    deleteProject(item) {
      this.axiosRequest('delete', `Projects/${item.projectID}`)
        .then(() => {
          this.$store.commit('projects/deleteById', item.projectID);
          this.deleteDialog = false;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    saveButton(button) {
      let method = 'post';
      let path = 'Buttons';
      if (button.buttonID) {
        method = 'put';
        path += '/' + button.buttonID;
      }

      let project = this.$store.getters['projects/byId'](button.projectID);

      this.axiosRequest(method, path, {
        organizationID: button.organizationID,
        projectID: button.projectID,
        title: button.title,
        titleLink: button.titleLink
      })
        .then(response => {
          if (!button.buttonID) {
            project.buttons.push(response.data);

            if (this.selectedProject) {
              this.$set(this.selectedProject, project);
            }
          } else {
            for (let y = 0; y < project.buttons.length; y++) {
              if (project.buttons[y].buttonID == response.data.buttonID) {
                this.$set(project.buttons, y, response.data);
              }
            }
          }
          this.$store.commit('projects/edit', project);
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    deleteButton(button) {
      console.log(button);
      if (!button.buttonID) return;

      this.axiosRequest('delete', `Buttons/${button.buttonID}`)
        .then(() => {
          let project = this.$store.getters['projects/byId'](button.projectID);
          for (let y = 0; y < project.buttons.length; y++) {
            if (project.buttons[y].buttonID == button.buttonID) {
              project.buttons.splice(y, 1);
              this.$store.commit('projects/edit', project);
              break;
            }
          }
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss">
.is-project-view {
  .grid-cell {
    height: 200px;
    position: relative;

    .background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-position: center;
      background-size: cover;

      &.is-gradient-null,
      &.is-gradient- {
        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.2);
        }
      }
    }

    .grid-title {
      display: none;
    }

    .grid-subtitle {
      position: absolute;
      bottom: 0px;
      padding-bottom: 1.5rem;

      .subtitle {
        font-size: 1.8rem;
      }
    }
  }
}
</style>
